import redirectInterceptor from "@/interceptors/redirect_interceptor";
import HttpError from "../http_error";

export default class WeatherRoutingAreaService {
  constructor(baseUrl, paDbUrl, companyId, customAreaFromJsonMapper, createCustomAreaToJsonMapper,) {
    this.baseUrl = baseUrl;
    this.paDbUrl = paDbUrl;
    this.companyId = companyId;
    this.customAreaFromJsonMapper = customAreaFromJsonMapper,
    this.createCustomAreaToJsonMapper = createCustomAreaToJsonMapper;
  }

  async post(accessToken, theyrAccessToken, customAreaData) {
    const requestBody = this.createCustomAreaToJsonMapper(customAreaData);
    const requestParams = {
      method: "POST",
      url: `${this.paDbUrl}/area`,
      headers: {
        accept: "application/json",
        "Content-type": "application/json",
        "access-token": `${accessToken}`,
        "theyr-token": `${theyrAccessToken}`,
        data: "{\"verified\":false}",
      },
      data: requestBody
    };
    try {
      await redirectInterceptor.request(requestParams);
    } catch (error) {
      throw new HttpError(error.response.statusText, error.response.status);
    }
  }

  async getMany(accessToken, theyrAccessToken) {
    try {
      const response = await redirectInterceptor.get(
        `${this.paDbUrl}/area`,
        {
          accept: "application/json",
          headers: {
            "access-token": `${accessToken}`,
            "theyr-token": `${theyrAccessToken}`,
          },
          params: {
            company_id: this.companyId
          }
        }
      );
      const result = response.data.map((datum) => this.customAreaFromJsonMapper(datum));
      return result;
    } catch (error) {
      throw new HttpError(error.response.statusText, error.response.status);
    }
  }

  async delete(accessToken, theyrAccessToken, id, theyrId) {
    try {
      await redirectInterceptor.delete(
        `${this.paDbUrl}/area/${id}`,
        {
          accept: "application/json",
          headers: {
            "access-token": `${accessToken}`,
            "theyr-token": `${theyrAccessToken}`,
          },
          params: {
            theyr_id: theyrId
          }
        }
      );
    } catch (error) {
      throw new HttpError(error.response.statusText, error.response.status);
    }
  }

}
